import retrieveLockeysHolderType from "./retrieveLockeysHolderType";
import isWeb3InteractionsAvailableForUser from "./isWeb3InteractionsAvailableForUser";

const logic = {
  retrieveLockeysHolderType,
  isWeb3InteractionsAvailableForUser,
};

export default logic;
